// Walk a React element tree (as returned by direct component invocation in tests)
// and collect every <img>'s props. Shared by the direct-invocation test suites
// (AbsolutePosImgs, CarouselItem) so the walker can't drift between copies.
export default function collectImgs(node, acc = []) {
  if (!node || typeof node !== 'object') return acc;
  if (Array.isArray(node)) {
    node.forEach((n) => collectImgs(n, acc));
    return acc;
  }
  if (node.type === 'img') acc.push(node.props);
  const children = node.props && node.props.children;
  if (children) collectImgs(children, acc);
  return acc;
}
